import React, { useEffect, useState } from "react";
import { DatePicker, Radio, Input, Checkbox } from "antd";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa6";
import RichTextEditor from "react-rte";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaFileDownload } from "react-icons/fa";

const { RangePicker } = DatePicker;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#358c97",
    color: theme.palette.common.white,
    fontSize: "0.7rem",
    padding: "2vh 0.5vh",
    fontWeight: "600",
    lineHeight: "normal",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "0.75rem",
    padding: "1.5vh",
    fontWeight: "700",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const RestaurantReport = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter_data, setfilter_data] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    let listimg_restaurants = [];
    if (search !== "") {
      listimg_restaurants = listimg_restaurants.filter((user) => {
        return user.mobile.toLowerCase().match(search.toLowerCase());
      });
    }
    setfilter_data([...listimg_restaurants]);
  }, [search]);

  const disableFutureDates = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.toDate() > today;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.65rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };

  return (
    <>
      <div className="user_report_filter_box">
        <div className="main_user_filer_box">
          <div className="user_rp_input_box_container">
            <InputLabel sx={input_lable_style} htmlFor="custom-input">
              Search
            </InputLabel>
            <TextField
              id="custom-input"
              placeholder="Search by Id/Email/Name/Phone Number"
              variant="outlined"
              autocomplete="off"
              size="small"
              className="user_report_input"
            />
          </div>
          <div className="user_rp_input_box_container">
            <InputLabel sx={input_lable_style} htmlFor="custom-input">
              Select Date
            </InputLabel>
            <RangePicker
              disabledDate={disableFutureDates}
              className="user_report_input"
            />
          </div>
          <div className="usr_rp_btn">Downlode CVS</div>
        </div>
      </div>

      <div className="margin_top_list">
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper} className="customScrollbar">
            <Table
              sx={{
                minWidth: 1000,
                boxShadow:
                  "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
              }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    ID
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    NAME
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    EMAIL
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    REGISTERED ON
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    ORDERS DELIVERED
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    REVINUE
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    COMMISSION
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {filter_data
                  .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                  .map((row, index) => ( */}
                <StyledTableRow
                //   key={index}
                //   sx={{
                //     backgroundColor: index % 2 === 0 ? "#cccccc" : "white",
                //   }}
                >
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                      textTransform: "uppercase",
                    }}
                    width={40}
                    align="center"
                  >
                    134556
                  </StyledTableCell>

                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={70}
                    align="center"
                  >
                    Nalla manoj
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={120}
                  >
                    manoj@gmail.com
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={60}
                  >
                    Oct 03,2024 04:15 PM
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={70}
                    align="center"
                  >
                    70
                  </StyledTableCell>
                  <StyledTableCell
                    width={100}
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    10000000
                  </StyledTableCell>
                  <StyledTableCell
                    width={50}
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    10%
                  </StyledTableCell>
                </StyledTableRow>
                {/* ))} */}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filter_data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
};

export default RestaurantReport;
